import React from 'react';
import { flowchartRows } from '../data/tables';
const toneStyles: Record<string, string> = {
  green: 'text-flag-green',
  amber: 'text-flag-amber',
  red: 'text-flag-red',
  neutral: 'text-ink-soft'
};
const toneDots: Record<string, string> = {
  green: 'bg-flag-green',
  amber: 'bg-flag-amber',
  red: 'bg-flag-red',
  neutral: 'bg-ink-muted'
};
export function FlowchartCard() {
  return <figure className="mx-auto mt-10 max-w-3xl" data-id="element-122" data-mp="390am21je4h58">
      <div className="overflow-hidden rounded-2xl border border-sage/15 bg-white shadow-page" data-id="element-123" data-mp="38yzia1py39e4">
        <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-b border-sage/15 px-5 py-3.5 sm:px-8" data-id="element-124" data-mp="341r1o5kg3dez">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-brass" data-id="element-125" data-mp="3ds2eyiq0qyyj">
            Vol. 1 — The 8 Seconds After They Tell You
          </p>
          <p className="font-sans text-[11px] text-ink-muted" data-id="element-126" data-mp="3rph89yje7qvs">Decision flow</p>
        </div>

        {/* Phones: each branch as its own step, no horizontal scrolling. */}
        <ol className="divide-y divide-sage/10 sm:hidden" data-id="element-127" data-mp="2o002ghjfbjf8">
          {flowchartRows.map((row, index) => <li key={`${row.answer}-${index}`} className="px-5 py-4" data-id="element-128" data-mp="2sybcas9pxtxg" data-mpi={index}>
              {row.question && <p className="font-sans text-[14px] font-semibold leading-snug text-ink" data-id="element-129" data-mp="2xvkz005q3rhl">
                  {row.question}
                </p>}
              <div className={row.question ? 'mt-3' : ''} data-id="element-130" data-mp="36y2joa5qcc2h">
                <p className="font-sans text-[14px] leading-snug text-ink-soft" data-id="element-131" data-mp="36vq76ciqqtwt">
                  If: {row.answer}
                </p>
                <p className={`mt-2 flex items-start gap-2 font-sans text-[14px] font-semibold leading-snug ${toneStyles[row.tone]}`} data-id="element-132" data-mp="3gmuc0jepcydx">
                  <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${toneDots[row.tone]}`} aria-hidden="true" data-id="element-133" data-mp="3potu7f1ge8ig" />
                  {row.output}
                </p>
              </div>
            </li>)}
        </ol>

        <div className="hidden px-5 py-6 sm:block sm:px-8 sm:py-8" data-id="element-134" data-mp="1qjtz3xhxiqlk">
          <table className="w-full border-collapse text-left" data-id="element-135" data-mp="1qhhaj1ho1hzj">
            <caption className="sr-only" data-id="element-136" data-mp="24c9waho5fuek">
              The decision flow: three questions a student can answer herself, and the resulting
              move.
            </caption>
            <thead data-id="element-137" data-mp="2e7tr10qz8n1q">
              <tr className="bg-sage text-white" data-id="element-138" data-mp="2e7bmlgu5v2iq">
                <th scope="col" className="rounded-l-lg px-4 py-2.5 font-sans text-[11px] font-semibold uppercase tracking-[0.12em]" data-id="element-139" data-mp="29a1x616ruquw">
                  Question
                </th>
                <th scope="col" className="px-4 py-2.5 font-sans text-[11px] font-semibold uppercase tracking-[0.12em]" data-id="element-140" data-mp="2ibrqxdo4m1vu">
                  Answer
                </th>
                <th scope="col" className="rounded-r-lg px-4 py-2.5 font-sans text-[11px] font-semibold uppercase tracking-[0.12em]" data-id="element-141" data-mp="ny9xxb4ycctf">
                  Your move
                </th>
              </tr>
            </thead>
            <tbody data-id="element-142" data-mp="2qqfiz2jbn6nk">
              {flowchartRows.map((row, index) => <tr key={`${row.answer}-${index}`} className="border-b border-sage/10 last:border-0" data-id="element-143" data-mp="2uskc805uy19o" data-mpi={index}>
                  <th scope="row" className="w-[38%] px-4 py-3.5 align-top font-sans text-[13px] font-semibold leading-snug text-ink" data-id="element-144" data-mp="2gsrq6i5a0981">
                    {row.question}
                  </th>
                  <td className="px-4 py-3.5 align-top font-sans text-[13px] leading-snug text-ink-soft" data-id="element-145" data-mp="27upijjr1eibs">
                    {row.answer}
                  </td>
                  <td className={`px-4 py-3.5 align-top font-sans text-[13px] font-semibold leading-snug ${toneStyles[row.tone]}`} data-id="element-146" data-mp="62b2yrbytpyj">
                    {row.output}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <figcaption className="mx-auto mt-5 max-w-2xl text-center font-sans text-[14px] leading-[1.6] text-ink-muted" data-id="element-147" data-mp="37j5e37avz4c0">
        You never need the diagnosis. Every question here is one the student can answer about her
        own experience — which is exactly what keeps you inside your scope.
      </figcaption>
    </figure>;
}